import { createFileRoute } from "@tanstack/react-router";
import { LaborSettingsPage } from "../../../../../pages/organisation-page/organisation-settings-pages";

export const Route = createFileRoute("/_auth/_organisation/organisation/resources/labor")({
  component: LaborSettingsPage,
});
